export const getSampleTypeSets = (item) => {
  let sampleTypeSets = {
    blood: new Set(),
    nonBlood: new Set(),
    dryIce: new Set()
  };
  // hardcode type for new 4 saliva tests
  if ([695, 698, 701, 704].includes(item.id)) {
    sampleTypeSets.nonBlood.add("Saliva");
    return sampleTypeSets;
  }
  let sampleTypeList = [];
  switch (item.category) {
    case "va":
    case "vw": {
      item.sampleTypeList.forEach(sampleType => {
        let [kitType, transformType] = getKitTypeForSampleType(sampleType);
          sampleTypeSets[kitType].add(transformType);
      });
      break;
    }
    case "discountPanel": {
      let { testList, packageList } = item.bundleContent;
      let testsAndPackages = (testList ? testList : [])
        .concat(packageList ? packageList : []);
      sampleTypeList = testsAndPackages
        .reduce((acc, item) => acc.concat(item.sampleTypeList ? item.sampleTypeList : []), [])
    break;
    }
    case "customPanel": {
      item.bundleItemList.forEach(item => {
        sampleTypeList = sampleTypeList.concat(item.sampleTypeList ? item.sampleTypeList : []);
      });
      break;
    }
    default:
      break;
  }

  sampleTypeList.forEach(sampleType => {
    let [kitType, transformType] = getKitTypeForSampleType(sampleType);
      sampleTypeSets[kitType].add(transformType);
  });

  // remove N/A
  sampleTypeSets.blood.delete("N/A");
  sampleTypeSets.nonBlood.delete("N/A");
  sampleTypeSets.dryIce.delete("N/A");

  return sampleTypeSets;
}

export const getSampleTypesInPromo = (promo, testList) => {
  let sampleTypeSets = {
    blood: new Set(),
    nonBlood: new Set(),
    dryIce: new Set()
  };
  let testsInPromo = testList
    .filter(t => promo.testIdsInPromo.has(t.id));
  ["blood", "nonBlood", "dryIce"].forEach(kit => {
    sampleTypeSets[kit]= testsInPromo.map(t => t.sampleTypeSets[kit])
      .reduce((acc, currSet) => new Set([...acc, ...currSet]), new Set());
  });
  // remove N/A
  sampleTypeSets.blood.delete("N/A");
  sampleTypeSets.nonBlood.delete("N/A");
  sampleTypeSets.dryIce.delete("N/A");
  return sampleTypeSets;
}

export function getSampleTypeSetsInXChooseY(xChooseY, testNodeList) {
  if (!xChooseY) {
    return;
  }
  let sampleTypeSets = {
    blood: new Set(),
    nonBlood: new Set(),
    dryIce: new Set()
  };
  let { selectedZoomerIdList, selectedSupplementIdList } = xChooseY;
  let testIdList = (selectedZoomerIdList ? selectedZoomerIdList : [])
    .concat(selectedSupplementIdList ? selectedSupplementIdList : []);
  let testsInXChooseY = testNodeList.filter(t => testIdList.includes(t.id)).map(t => t.value);
  ["blood", "nonBlood", "dryIce"].forEach(kit => {
    sampleTypeSets[kit]= testsInXChooseY.map(t => t.sampleTypeSets[kit])
      .reduce((acc, currSet) => new Set([...acc, ...currSet]), new Set());
  });
  // remove N/A
  sampleTypeSets.blood.delete("N/A");
  sampleTypeSets.nonBlood.delete("N/A");
  sampleTypeSets.dryIce.delete("N/A");
  return sampleTypeSets;
}

// find corresponding kit type for given sample type
// return [ kitType, sampleType ]
function getKitTypeForSampleType(type) {
  let transformName = processNametransform(type);
  if (dryIceEligibleTypeList.includes(type.toLowerCase())) {
    return ["dryIce", transformName];
  }
  else {
    let kit = processBloodOrNonBloodKit(type);
    return [kit, transformName];
  }
}

// sample type name transforms
function processNametransform(name) {
  switch(name.toLowerCase()) {
    case "frozen serum":
      return "Serum";
    case "metal free urine":
    case "urine_m":
    case "urine_a":
    case "urine_e":
    case "urine_n":
      return "Urine";
    case "urine_uti":
      return "Urine UTI";
    case "urine_analysis":
      return "Urinalysis";
    case "sodium citrate plasma":
    case "plasma_edta":
    case "plasma_edta_platelet_free":
    case "plasma_citrate_platelet_poor":
    case "plasma_edta_trasylol":
      return "Plasma";
    case "dna fingerprick":
      return "DNA";
    case "blood fingerprick":
      return "DBS";
    case "Shit":
    case "unpreserved stool":
      return "Stool";
    case "saliva_m":
    case "saliva_a":
    case "saliva_e":
    case "saliva_n":
    case "saliva_mb":
    case "saliva_ma":
    case "saliva_i":
    case "covid_stool": // special case: COVID_STOOL is Saliva, not covid
      return "Saliva";
    case "covid_npswab":
    case "covid19_sst":
    case "covid19_fingerprick":
      return "COVID";
    case "blood microtube":
      return "Microtube";
    case "sodium_citrate_plasma":
      return "Sodi Citra Plasma";
    default:
      return name;
  }
}

// sample type that eligible for dry ice kit
const dryIceEligibleTypeList = [
  "frozen serum", 
  "plasma_edta",
  "plasma_edta_platelet_free",
  "plasma_citrate_platelet_poor",
  "plasma_edta_trasylol"
]

// return non blood kit or blood kit according to sampleType
/* unknown exceptions:
   Swab,Swab,Non Blood Kit ------ Swab,Swab,Blood Kit
*/
export function processBloodOrNonBloodKit(sampleType) {
  switch(sampleType.toLowerCase()) {
    case "serum":
    case "frozen serum":
    case "edta":
    case "esr":
    case "plasma":
    case "sodium citrate plasma":
    case "sodium_citrate_plasma":
    case "plasma_edta":
    case "plasma_edta_platelet_free":
    case "plasma_citrate_platelet_poor":
    case "plasma_edta_trasylol":
    case "tes":
    case "edta_mn":
    case "covid19_sst":
      return "blood";
    default:
      return "nonBlood"; 
  }
}

const URINE_4_CODES = new Set(["urine_e", "urine_a", "urine_m", "urine_n"]);
const SALIVA_6_CODES = new Set(["saliva_e", "saliva_m", "saliva_n", "saliva_ma", "saliva_mb", "saliva_i"]);

export function getSampleTypeSetsNew(item) {
  const sets = {
    blood: new Set(),
    nonBlood: new Set(),
    dryIce: new Set(),
  };

  if (!item) return sets;

  let sampleTypeList = [];
  switch (item.category) {
    case "va":
    case "vw":
      sampleTypeList = item.sampleTypeList || [];
      break;

    case "discountPanel": {
      const { testList = [], packageList = [] } = item.bundleContent || {};
      sampleTypeList = [...testList, ...packageList].flatMap(t => t.sampleTypeList || []);
      break;
    }

    case "customPanel":
      sampleTypeList = (item.bundleItemList || []).flatMap(t => t.sampleTypeList || []);
      break;

    default:
      sampleTypeList = item.sampleTypeList || [];
  }

  let urineCodeCount = 0;
  let salivaCodeCount = 0;

  for (const raw0 of sampleTypeList) {
    if (!raw0) continue;

    const rawLower = String(raw0).toLowerCase();

    if (URINE_4_CODES.has(rawLower)) urineCodeCount++;
    if (SALIVA_6_CODES.has(rawLower)) salivaCodeCount++;

    const tagKey = RAW_SAMPLE_TYPE_TO_TAG_KEY_NEW[rawLower] || null;
    if (!tagKey || tagKey === "N/A") continue;

    const kitType = processBloodOrNonBloodKit(rawLower);

    if (kitType === "blood") {
      sets.blood.add("Blood");
    } else {
      sets.nonBlood.add(tagKey); 
    }
  }

  if (sets.nonBlood.has("Urine") && urineCodeCount === 4) {
    sets.nonBlood.delete("Urine");
    sets.nonBlood.add("Urine (4 Tubes)");
  }

  if (sets.nonBlood.has("Saliva") && salivaCodeCount === 6) {
    sets.nonBlood.delete("Saliva");
    sets.nonBlood.add("Saliva (6 Tubes)");
  }

  return sets;
}

// New beta tag
export const RAW_SAMPLE_TYPE_TO_TAG_KEY_NEW = {
  // urine
  "metal free urine": "Urine",
  "urine": "Urine",
  "urine_e": "Urine",
  "urine_a": "Urine",
  "urine_m": "Urine",
  "urine_n": "Urine",

  // stool
  "unpreserved stool": "Stool",
  "stool": "Stool",

  // saliva
  "saliva": "Saliva",
  "saliva_m": "Saliva",
  "saliva_a": "Saliva",
  "saliva_e": "Saliva",
  "saliva_n": "Saliva",
  "saliva_mb": "Saliva",
  "saliva_ma": "Saliva",
  "saliva_i": "Saliva",

  // blood variants
  "blood fingerprick": "DBS",
  "blood microtube": "Microtube",

  // blood tubes
  "edta": "Blood",
  "serum": "Blood",
  "tes": "Blood",
  "plasma": "Blood",
};

export function getSampleTypeTagInfoFromSetsNew(
  sampleTypeSets = { blood: new Set(), nonBlood: new Set(), dryIce: new Set() }
) {
  try {
    const keysSet = new Set();

    const blood = sampleTypeSets?.blood;
    const nonBlood = sampleTypeSets?.nonBlood;
    const dryIce = sampleTypeSets?.dryIce;

    if (blood && blood.size > 0) {
      for (const k of blood) keysSet.add(k);
    }

    if (nonBlood && nonBlood.size > 0) {
      for (const k of nonBlood) keysSet.add(k);
    }

    if (dryIce && dryIce.size > 0) {
      for (const k of dryIce) keysSet.add(k);
    }

    const keys = Array.from(keysSet);
    return { keys, single: keys[0] || "" };
  } catch (e) {
    return { keys: [], single: "" };
  }
}